module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/shared/navbar/navbar.component.css
// module id = ./src/app/components/calculator/calculator-item/shared/navbar/navbar.component.css
// module chunks = main